module.exports = __webpack_public_path__ + "img/H1.fe8f7737.png";